<template>
  <a-modal
    title="编辑信息"
    width="500px"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-tabs defaultActiveKey="picture" type="card">
      <a-tab-pane tab="图像" key="picture">
        <a-spin :spinning="spinning">
          <a-card style="margin:2px 2px 2px 2px" :bordered="true">
            <img width="100%" :src="image" @load="noSpinning">
          </a-card>
        </a-spin>
      </a-tab-pane>
      <a-tab-pane tab="详情" key="details" :forceRender="true">
        <a-card :body-style="{padding: '2px 2px'}" :bordered="false">

          <a-form @submit="handleSubmit" :form="form">

            <a-form-item
              label="数据编号"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <span style="padding-left:10px" >{{ `${data_id}` }}</span>
            </a-form-item>

            <a-form-item
              label="数据来源"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <select-hospital ref="hospital" :theDefaultValue="hospital" v-if="opened"/>
            </a-form-item>

            <a-form-item
              label="患者姓名"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <a-input placeholder="输入患者姓名" v-decorator="[ 'case_name']" />
            </a-form-item>

            <a-form-item
              label="患者姓别"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <a-select placeholder="请选择患者姓别" v-decorator="['case_gender',]" >
                <a-select-option value="0">男</a-select-option>
                <a-select-option value="1">女</a-select-option>
                <a-select-option value="2">未知</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item
              label="患者年龄"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <a-input
                name="age"
                placeholder="输入患者年龄"
                v-decorator="['case_age',{rules: [{pattern:'^\\d{1,3}$',message: '请输入正常年龄'}]}]" />
            </a-form-item>

            <a-form-item
              label="备注信息"
              :labelCol="{lg: {span: 6}, sm: {span: 7}}"
              :wrapperCol="{lg: {span: 14}, sm: {span: 10} }">
              <a-textarea placeholder="输入备注信息" v-decorator="['data_des']" />
            </a-form-item>

          </a-form>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import SelectHospital from '@/components/selector/SelectHospital'
import { editData, editTaskData } from '@/api/data'
import { DEFAULT_IMAGE } from '@/utils/const'
import { fetchFileUrl } from '@/api/file'
import { axios } from '@/utils/request'

export default {
  name: 'EditDataModal',
  components: {
    SelectHospital
  },
  data () {
    return {
      image: DEFAULT_IMAGE,
      visible: false,
      data_id: '',
      hospital: '',
      case_name: '',
      case_gender: '',
      case_age: '',
      data_des: '',
      id: '',
      opened: false,
      form: this.$form.createForm(this),
      spinning: false,
      storeToken: '',
    }
  },

  methods: {
    edit (record) {
      this.visible = false
      this.opened = false
      const _this = this
      this.image = DEFAULT_IMAGE
      this.$nextTick(() => {
        _this.spinning = true
        fetchFileUrl({ data_id: record.data_id }).then(res => {
          debugger
          var urlArray = res.data.split("?")
          _this.getNdpiToken()
          setTimeout(() => {
            debugger
            const imageUrl = urlArray[0] + _this.storeToken + "/?" + urlArray[1]
            _this.image = imageUrl
          }, 1000)
        })
        _this.visible = true
        _this.opened = true
        _this.id = record.origin_data.id
        _this.data_id = record.data_id
        _this.hospital = record.origin_data.source_id
        _this.$nextTick(() => {
          _this.form.setFieldsValue({
            case_name: record.case_name,
            case_gender: record.origin_data.case_gender,
            data_des: record.origin_data.data_des,
            case_age: record.origin_data.case_age + ''
          })
        })
      })
    },
    getNdpiToken() {
      const _this = this
      axios({
        method: 'get',
        url: '/item/data/token',
        //timeout: 1000 * 60 * 2
      }).then(res => {
        _this.storeToken = res.token
      })
    },
    noSpinning () {
      debugger
      this.spinning = false
    },
    handleCancel () {
      this.visible = false
      this.opened = false
    },
    // handler
    handleOk () {
      //
      const _this = this
      this.form.validateFields((err, values) => {
        //
        if (!err) {
          const params = {
            id: _this.id,
            source_id: this.$refs.hospital.value || this.$refs.hospital.theDefaultValue,
            data_des: values.data_des,
            case_name: values.case_name,
            case_gender: values.case_gender,
            case_age: values.case_age
          }
          var request = editData
          if (_this.$store.getters.isProjectCreater) request = editTaskData
          request(params).then(res => {
            _this.$message.success('修改成功')
            _this.$emit('dataChanged')
            _this.visible = false
            _this.opened = false
          }).catch((err) => {
            _this.$message.error('修改失败')
          })
        }
      })
    }
  }
}
</script>
